module.exports = __webpack_public_path__ + "static/media/AccountInfo.8773442b.svg";